<template>
    <div>
        <div class="columns">
            <cars-search :cars="cars"></cars-search>
        </div>
        <app-loader :loading="getLoaderStatus" :color="options.color" :size="options.size"></app-loader>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column has-text-centered">
                <h3 class="title">Total: {{ totalCars }}</h3>
            </div>
        </div>
        <div class="columns"  v-if="!getLoaderStatus">
            <div class="column">
                <div class="field">
                    <div class="control">
                        <div class="select is-small">
                            <select v-model="show_rows">
                                <option v-for="row in rows" :value="row">{{ row }} rows per page.</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns center" v-if="!getLoaderStatus">
            <div class="table-container center-column">
                <table class="table is-responsive-table is-fullwidth is-scrollable is-striped">
                    <thead>
                    <th :class="{'headcol headcol-1' : isAdmin}">Photos</th>
                    <th :class="{'headcol headcol-2' : isAdmin}"><span @click="setOrder('bid')"  class="link">Lot</span></th>
                    <th :class="{'headcol headcol-3' : isAdmin }"><span @click="setOrder('model_type_en')" class="link">Chassis</span></th>
                    <th v-if="isAdmin || isSalesStaff" :class="{ 'main-head': isAdmin  }">Select</th>
                    <th><span @click="setOrder('shipping_group_id')"  class="link">S.Group</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('manager_id')"  class="link">Manager</span></th>
                    <th><span @click="setOrder('created_at')" class="link">Buy</span></th>
                    <th><span @click="setOrder('shipping_group_id')"  class="link">S.Group</span></th>
                    <th><span @click="setOrder('auction_name')" class="link">Auction</span></th>
                    <th><span @click="setOrder('company')" class="link">Brand</span></th>
                    <th><span @click="setOrder('model_name_en')" class="link">Model</span></th>
                    <th><span @click="setOrder('model_year_en')" class="link">Year</span></th>
                    <th><span @click="setOrder('price')" class="link">Result</span></th>
                    <th><span @click="setOrder('invoice_number')" class="link">Invoice#</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('balance')" class="link">Payment</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('balance')" class="link tooltip" data-tooltip="Payment Date">PD</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('remarks')" class="link">Remarks</span></th>
                    <th><span @click="setOrder('balance')" class="link">Balance</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('inland_company')" class="link">Inland</span></th>
                    <th><span @click="setOrder('yard_arrival_date')" class="link tooltip" data-tooltip="Yard Arrival Date">YAD</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('yard')" class="link">Yard</span></th>
                    <th><span @click="setOrder('yard_pics')" class="link">PICS</span></th>
                    <th><span @click="setOrder('port_of_loading')" class="link">POL</span></th>
                    <th><span @click="setOrder('port_of_arrival')" class="link">POA</span></th>
                    <th><span @click="setOrder('shipping_line')" class="link">Line</span></th>
                    <th><span @click="setOrder('vessel')" class="link">Vessel</span></th>
                    <th><span @click="setOrder('created_at')" class="link">Lapse</span></th>
                    <th><span @click="setOrder('docs_received')" class="link">Docks</span></th>
                    <th><span @click="setOrder('export_certificate')" class="link">EC</span></th>
                    <th v-if="isAdmin"><span class="tooltip" data-tooltip="Export Declaration">ED</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('inspection')" class="link tooltip" data-tooltip="Inspection">Ins.</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('inspection_date')" class="link tooltip" data-tooltip="Date of inspection">DOI</span></th>
                    <th><span @click="setOrder('estimated_departure')" class="link">ETD</span></th>
                    <th><span @click="setOrder('estimated_arrival')" class="link">ETA</span></th>
                    <th><span @click="setOrder('bill_of_landing')" class="link">B/L</span></th>
                    <th><span @click="setOrder('docs_send')" class="link">Post</span></th>
                    <th v-if="isAdmin"><span @click="setOrder('insurance_date')" class="link">Insurance</span></th>
                    </thead>
                    <car-table-row v-for="(car, i) in cars" :car="car" :key="car.id" :i="i"></car-table-row>
                </table>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column has-text-centered">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                        <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                        <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                        <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                        <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
        <shipping-group-modal></shipping-group-modal>
        <create-mulit-proforma-modal></create-mulit-proforma-modal>
    </div>
</template>

<script>
    import CarsSearch from './CarsSearch'
    import appLoader from 'vue-spinner/src/ClipLoader'
    import CarTableRow from './UserGarageTableRow.vue'
    import ShippingGroupModal from './ShippingGroupModal.vue'
    import CreateMulitProformaModal from "../../../../Cars/CreateMulitProformaModal";
    export default {
        components: {
            CreateMulitProformaModal,
            carsSearch: CarsSearch,
            appLoader: appLoader,
            carTableRow: CarTableRow,
            ShippingGroupModal
        },
        data() {
            return {
                options: this.$store.getters.getOptions,
                scrollPosition: null,
                rows: [ 15, 25, 50, 100]
            }
        },
        computed: {
            show_rows: {
                get() {
                    return this.$store.getters.getCarsQuery.show_rows
                },
                set(value) {
                    this.$store.dispatch('setCarsQueryFieldValue', {
                        field: 'show_rows',
                        value: value
                    })
                    this.$store.dispatch('fetchCars')
                }
            },
            cars() {
                return this.$store.getters.getCars
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            isLastPage() {
                return this.$store.getters.isLastCarsPage
            },
            totalCars() {
                return this.$store.getters.getTotalsCarsNumber
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            getCurrentPage() {
                return this.$store.getters.getCurrentCarsPage
            },
            getFirstPage() {
                return this.$store.getters.getCarsFirstPage
            },
            getLastPage() {
                return this.$store.getters.getLastCarsPage
            }
        },
        methods: {
            changePage(page) {
                this.$store.dispatch('loadMoreCars', page)
            },
            isMobile() {
                return (window.innerWidth <= 760)
            },
            setOrder(column) {
                this.$store.getters.getCarsOrderType === 'ASC' ? this.$store.dispatch('setCarsNewOrderType', 'DESC') : this.$store.dispatch('setCarsNewOrderType', 'ASC')
                this.$store.dispatch('setCarsNewOrderColumn', column)
                this.$store.dispatch('fetchCars')
            },
            updateScroll() {
                this.scrollPosition = window.scrollY
            }
        },
        created() {
            this.$store.dispatch('clearCarsQuery')
            if (location.pathname.split('/')[1] === 'users'){
                this.$store.dispatch('updateCarsQueryUserId', this.$route.params.id)
                this.$store.dispatch('fetchShippingGroups', this.$route.params.id)
            }
            this.$store.dispatch('fetchCars')
            window.addEventListener('scroll', this.updateScroll);
        },
        destroy() {
            window.removeEventListener('scroll', this.updateScroll)
        }
    }
</script>

<style scoped>
    .tbody-container {
        max-height: 700px;
        overflow-y: scroll;
    }
    .table-container {
        max-width: 100%;
        overflow: -moz-scrollbars-vertical;
        overflow-y: scroll;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .center, .center-column, .top, .right, .bottom, .left {
        justify-content: center;
        align-items: center;
    }
    .headcol {
        position: absolute;
        z-index: 1;
        background-color: white;
    }
    .headcol-1 {
        width: 70px;
    }
    .headcol-2 {
        margin-left: 70px;
        width: 100px;
        text-align: center;
    }
    .headcol-3 {
        margin-left: 150px;
        width: 150px;
        text-align: center;
    }
    .headcol-4 {
        margin-left: 300px;
    }
    .main-head {
        padding-left: 320px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/Garage/UserGarageTable.vue